import { SofaSingleIcon } from './SofaSingleIcon';

/**
 * author: Michael Irigoyen
 * id 61A9F431-1946-4F8F-9DB4-19E75151D397
 * name sofa-single
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sofa-single.svg
 * tags
 * - Home Automation 
 */
export const LoveseatIcon = SofaSingleIcon;
export default LoveseatIcon